import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chart_added",
  "use": "chart_added-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"chart_added\"><path d=\"M15.5 10.56V4.38L12 .88l-6 6-2-2-3.5 3.5v3.06c0 2.24 1.82 4.06 4.06 4.06h4.7c-.3-.46-.53-.96-.65-1.5H4.56C3.15 14 2 12.85 2 11.44V9l2-2 2 2 6-6 2 2v4.66c-.32-.1-.65-.16-1-.16-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5c0-.95-.38-1.81-1-2.44zm-.5 3.19h-1.25V15h-1.5v-1.25H11v-1.5h1.25V11h1.5v1.25H15v1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol